export const FLAGS = {
  en: "https://dh5od79hpom3m.cloudfront.net/flags/gb.svg",
  de: "https://dh5od79hpom3m.cloudfront.net/flags/de.svg",
  fr: "https://dh5od79hpom3m.cloudfront.net/flags/fr.svg",
  es: "https://dh5od79hpom3m.cloudfront.net/flags/es.svg",
  it: "https://dh5od79hpom3m.cloudfront.net/flags/it.svg",
  pt: "https://dh5od79hpom3m.cloudfront.net/flags/pt.svg",
  zh: "https://dh5od79hpom3m.cloudfront.net/flags/cn.svg",
};
